module.exports = __webpack_public_path__ + "img/upperabs-ectomorph-female.79354952.svg";